<div class="main-toolbar mat-elevation-z2">
  <div>
    <button (click)="sidenav.open()" mat-icon-button>
      <mat-icon>menu</mat-icon>
    </button>
  </div>

  <mee-breadcrumbs *ngIf="showBreadcrumbs"></mee-breadcrumbs>

  <span></span>

  <div class="user-button-container">
    <mee-toolbar-user-button></mee-toolbar-user-button>
  </div>
</div>
